import React from 'react'

const NotificationsListItemLoader = () => (
  <div className="loader feed-list-item-loader" style={{ padding: 16 }}>
    <div
      className="loader-row"
      style={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        marginRight: 16,
      }}
    />
    <div style={{ flexGrow: 1 }}>
      <div
        className="loader-row"
        style={{
          width: '90%',
          height: 13,
        }}
      />
      <div
        className="loader-row"
        style={{
          width: '70%',
          height: 13,
          marginTop: 8,
        }}
      />
      <div
        className="loader-row"
        style={{
          width: '40%',
          height: 13,
          marginTop: 20,
        }}
      />
    </div>
  </div>
)

NotificationsListItemLoader.displayName = 'NotificationsListItemLoader'

export default NotificationsListItemLoader
